import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, CircularProgress, IconButton, Snackbar, Typography, useTheme } from '@mui/material';
import React from 'react'
import Header from '../../../../components/Header';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import { tokens } from '../../../../theme';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../../../context/UserContext';
import BubbleBox from '../../../../components/BubbleBox';
import QuestionBox from '../../../../components/QuestionBox';
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bubble } from 'react-chartjs-2';
import BrandProdcutDialog from '../../../../components/BrandProdcutDialog';
import InfiniteScroll from 'react-infinite-scroll-component';
import BrandProductBox from '../../../../components/BrandProductBox';
import AlertDialogSlide from '../../../../components/AlertDialogSlide';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

function CouponDetails() {
    const navigate = useNavigate();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { token } = useContext(UserContext);
    const adId = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1];
    const userId = window.location.pathname.split("/")[window.location.pathname.split("/").length - 2] === "coupon-details" ? null : window.location.pathname.split("/")[window.location.pathname.split("/").length - 2];

    const [ad, setAd] = useState(null);
    const [bubbles, setBubbles] = useState([]);
    const [adQuestions, setAdQuestions] = useState([]);
    const [userWatches, setUserWatches] = useState([]);
    const [brandProducts, setBrandProducts] = useState([]);
    const [data, setData] = useState(null);
    const [productDialogOpen, setProductDialogOpen] = useState(false);
    const [targetProduct, setTargetProduct] = useState(null);
    const [hasMoreProduct, setHasMoreProduct] = useState(true);
    const [alertDialogOpen, setAlertDialogOpen] = useState(false);
    const [targetProductToDelete, setTargetProductToDelete] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarInfo, setSnackbarInfo] = useState({ type: "success", message: "" });

    useEffect(() => {
        fetchAdData();
        getStatistics();
        getBrandProducts(0);
    }, []);

    useEffect(() => {
        if (targetProduct) {
            setProductDialogOpen(true);
        }
    }, [targetProduct]);

    useEffect(() => {
        if (targetProductToDelete) {
            setAlertDialogOpen(true);
        } else {
            setAlertDialogOpen(false);
        }
    }, [targetProductToDelete]);

    const handleEditProduct = (product) => {
        setTargetProduct(product);
    };

    const handleDeleteProduct = () => {
        const deletedProductId = targetProductToDelete.id;
        axios.delete(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/deleteBrandProduct?brandProductId=${deletedProductId}&token=${token}`)
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    setBrandProducts((products) => products.filter((product) => product.id !== deletedProductId));
                    setSnackbarInfo({ type: "success", message: "Ürün başarıyla silindi." });
                } else {
                    setSnackbarInfo({ type: "error", message: "Ürün silinemedi, lütfen tekrar deneyin." });
                }
                setSnackbarOpen(true);
            })
            .catch((err) => {
                console.log("err: " + err);
                setSnackbarInfo({ type: "error", message: "Ürün silinemedi, lütfen tekrar deneyin." });
                setSnackbarOpen(true);
            })
            .finally(() => {
                setTargetProductToDelete(null);
            });
    };

    const fetchAdData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getAdDetails?token=${token}&id=${adId}`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    if (response.data.ad) {
                        setAd(response.data.ad);
                        if (response.data.ad.bubbles) {
                            if (userId) {
                                axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getBubbles?token=${token}&userId=${userId}&adId=${adId}`)
                                    .catch((err) => {
                                        console.log("err: " + err);
                                        setBubbles([]);
                                    })
                                    .then((response) => {
                                        if (response && response.data.success === true && response.data.status === 200) {
                                            if (response.data.bubbles) {
                                                setBubbles(response.data.bubbles);
                                            }
                                        }
                                    });
                            } else {
                                setBubbles(response.data.ad.bubbles);
                            }
                        }
                        if (response.data.ad.questions) {
                            if (userId) {
                                axios.get(`${process.env.REACT_APP_API_URL}api/alcago/answer/getQuestionsWithAnswers?token=${token}&userId=${userId}&adId=${adId}`)
                                    .catch((err) => {
                                        console.log("err: " + err);
                                        setAdQuestions([]);
                                    })
                                    .then((response) => {
                                        if (response && response.data.success === true && response.data.status === 200) {
                                            if (response.data.questions) {
                                                setAdQuestions(response.data.questions);
                                            }
                                        }
                                    });
                            } else {
                                setAdQuestions(response.data.ad.questions);
                            }
                        }
                        if (userId) {
                            axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getWatchData?token=${token}&userId=${userId}&adId=${adId}`)
                                .catch((err) => {
                                    console.log("err: " + err);
                                    setUserWatches([]);
                                })
                                .then((response) => {
                                    if (response && response.data.success === true && response.data.status === 200) {
                                        if (response.data.watchData) {
                                            setUserWatches(response.data.watchData);
                                        }
                                    }
                                });
                        }
                    }
                }
            });
    }

    const getBrandProducts = (startIndex) => {
        if (!userId) {
            axios.get(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/getBrandProducts?token=${token}&adId=${adId}&startIndex=${startIndex}`)
                .catch((err) => {
                    console.log("err: " + err);
                    setHasMoreProduct(false);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 200) {
                        if (response.data.brandProducts) {
                            setBrandProducts(response.data.brandProducts);
                            if (response.data.brandProducts.length < 20) {
                                setHasMoreProduct(false);
                            }
                        }
                    }
                });
        }
    }

    const getStatistics = () => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getBubbleTouches?token=${token}&adId=${adId}`)
            .catch((err) => {
                console.log("err: " + err);
                setData({
                    labels: ["x kordinatı", "y kordinatı"],
                    datasets: [
                        {
                            label: 'Patlatılan Baloncuk Pozisyonları',
                            backgroundColor: "#868dfb",
                            borderColor: "#868dfb",
                            data: [{ x: 0, y: 0 }],
                            pointRadius: 10,
                            datalabels: {
                                display: false
                            }
                        }
                    ],
                });
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setData({
                        labels: ["x kordinatı", "y kordinatı"],
                        datasets: [
                            {
                                label: 'Patlatılan Baloncuk',
                                backgroundColor: "rgba(40, 161, 44, 0.35)",
                                data: response.data.bubbleTouches.filter((bt) => bt.type === 1 && bt.touched === 1),
                                pointRadius: 10,
                                datalabels: {
                                    display: false
                                }
                            },
                            {
                                label: 'Patlatılmayan Baloncuk',
                                backgroundColor: "rgba(186, 22, 22, 0.35)",
                                data: response.data.bubbleTouches.filter((bt) => bt.type === 1 && bt.touched === 0),
                                pointRadius: 10,
                                datalabels: {
                                    display: false
                                }
                            }, {
                                label: 'Patlatılmayan Bomba',
                                backgroundColor: "rgba(40, 161, 44, 0.35)",
                                data: response.data.bubbleTouches.filter((bt) => bt.type === 0 && bt.touched === 0),
                                pointRadius: 10,
                                datalabels: {
                                    display: false
                                }
                            }, {
                                label: 'Patlatılan Bomba',
                                backgroundColor: "rgba(186, 22, 22, 0.35)",
                                data: response.data.bubbleTouches.filter((bt) => bt.type === 0 && bt.touched === 1),
                                pointRadius: 10,
                                datalabels: {
                                    display: false
                                }
                            }
                        ],
                    });

                }
            });
    }

    const getFindFromStr = (key) => {
        const findFroms = {
            wallet_page_featured: "Cüzdan Sayfası - Öne Çıkarılmış Reklamlar",
            main_page_featured: "Ana Sayfa - Öne Çıkarılmış Reklamlar",
            main_page_not_complated: "Ana Sayfa - Yarıda Kalanlar",
            brand_profile_coupons: "Marka Profili - Marka Kuponları",
            all_ads_page: "İnteraktif Reklamlar Sayfası",
            brand_other_coupons: "Reklam Detay Sayfası - Markanın Diğer Kuponları",
            saved_ads_featured: "Kaydedilen Reklamlar Sayfası - Öne Çıkarılmış Reklamlar",
            saved_ads_saveds: "Kaydedilen Reklamlar",
            brand_profile_product_card: "Marka Profili - Ürün Kartı",
            product_page: "Ürün Sayfası"
        }
        if (!key || !findFroms[key]) return "Bilinmiyor";
        return findFroms[key];
    }

    const updateAd = () => {
        axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/ad/updateAd?token=${token}&adId=${adId}`, { ad: { is_active: ad.is_active === 1 ? 0 : 1 } })
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    setAd({ ...ad, is_active: ad.is_active === 1 ? 0 : 1 });
                }
            });
    }

    const handleBrandProductSave = async (values) => {
        if (values.image1 || values.image2 || values.image3) {
            await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/uploadBrandProductImages?token=${token}`, {
                ...(values.image1 ? { image1: values.image1 } : {}),
                ...(values.image2 ? { image2: values.image2 } : {}),
                ...(values.image3 ? { image3: values.image3 } : {})
            }, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        if (values.image1) {
                            delete values.image1;
                            delete values.image_path_1;
                            values.image_path_1 = response.data.imagePath1;
                        }
                        if (values.image2) {
                            delete values.image2;
                            delete values.image_path_2;
                            values.image_path_2 = response.data.imagePath2;
                        }
                        if (values.image3) {
                            delete values.image3;
                            delete values.image_path_3;
                            values.image_path_3 = response.data.imagePath3;
                        }
                    }
                });
        }

        delete values.image1;
        delete values.image2;
        delete values.image3;
        if (targetProduct) {
            //update

            const productIndex = brandProducts.findIndex((bp) => bp.id === targetProduct.id);

            if (productIndex !== -1) {
                const updatedProducts = [...brandProducts];
                updatedProducts[productIndex] = { ...updatedProducts[productIndex], ...values };
                setBrandProducts(updatedProducts);
            }
            delete values.image_link_1;
            delete values.image_link_2;
            delete values.image_link_3;
            axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/updateBrandProduct?brandProductId=${targetProduct.id}&token=${token}`, { brandProduct: values })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        setProductDialogOpen(false);
                        setTargetProduct(null);
                    }
                });
        } else {
            //create
            axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/?token=${token}`, { brandProduct: values })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        setProductDialogOpen(false);
                    }
                });
        }
    };

    const deleteAd = () => {
        axios.delete(`${process.env.REACT_APP_API_URL}api/alcago/ad/deleteAd?token=${token}&adId=${adId}`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    navigate("/admin-panel/ads");
                }
            });
    }

    return (
        <Box mt="20px">
            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.message}
                </Alert>
            </Snackbar>
            {!ad &&
                <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress color="inherit" />
                </Box>
            }
            {ad &&
                <Box>
                    <AlertDialogSlide
                        open={alertDialogOpen} handleClose={() => setTargetProductToDelete(null)}
                        clickPositiveAnswer={handleDeleteProduct} clickNegativeAnswer={() => setTargetProductToDelete(null)}
                        positiveAnswer={"Sil"} negativeAnswer={"İptal"}
                        title={"Bu ürünü silmek istediğinize emin misiniz?"}
                        description={"Bu ürün ile ilişkili tüm veriler silinecektir."}
                    />
                    <BrandProdcutDialog
                        open={productDialogOpen}
                        handleClose={() => setProductDialogOpen(false)}
                        handleSubmit={handleBrandProductSave}
                        brandProduct={targetProduct}
                        adType={"regularAd"}
                        brandId={ad.brand_id}
                        adId={adId}
                    />
                    <Box display="flex">
                        <Box display="flex">
                            <IconButton style={{ width: "40px", height: "40px", marginRight: "5px" }}
                                onClick={() => {
                                    if (userId) {
                                        navigate("/admin-panel/users");
                                    } else {
                                        navigate("/admin-panel/ads");
                                    }
                                }}>
                                <ArrowBackIosNewOutlinedIcon />
                            </IconButton>
                            <Box display="flex" mr="5px">
                                <img
                                    alt="profile-user"
                                    src={ad.thumbnail_image_link}
                                    width="40px"
                                    height="40px"
                                    style={{ cursor: "pointer", borderRadius: "50%" }} />
                            </Box>
                            <Box display="flex" gap={"30px"} ml="10px">
                                <Header title={ad.brand_name} subtitle={ad.title} />
                                {!userId &&
                                    <>
                                        {ad.remaining_coupon_count === ad.starting_coupon_count &&
                                            <Button variant='contained' color={'error'} sx={{ margin: "10px 0 auto 20px" }} onClick={deleteAd}>
                                                Reklamı Sil
                                            </Button>
                                        }
                                        <Button variant='contained' color={ad.is_active === 1 ? 'error' : 'success'} sx={{ margin: "10px 0 auto 20px" }} onClick={updateAd}>
                                            {ad.is_active === 1 ? "Reklamı Pasifleştir" : "Reklamı Aktifleştir"}
                                        </Button>
                                        {ad?.has_coupons !== 0 &&
                                            <Button
                                                variant='contained'
                                                color='success'
                                                sx={{ margin: "10px 0 auto 0" }}
                                                onClick={() => {
                                                    setProductDialogOpen(true);
                                                }}
                                            >
                                                Ürün Ekle
                                            </Button>
                                        }
                                    </>
                                }
                            </Box>
                        </Box>

                    </Box>
                    <Box mx="30px" pt="20px" sx={{ background: colors.primary[400], borderRadius: "20px" }}>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="150px" maxWidth="250px" ml="20px" mb="20px"><b>Yayınlanma Tarihi</b> <hr />{new Date(ad.created_date).toLocaleTimeString("tr-TR", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Kupon Sayısı</b> <hr />{ad.remaining_coupon_count + "/" + ad.starting_coupon_count}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>İzlenme Sayısı</b> <hr />{ad.watch_count}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Baloncuk Sayısı</b> <hr />{bubbles.length}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Reklama Özel Soru Sayısı</b> <hr />{adQuestions.length}</Typography>
                        {userId &&
                            <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="150px" maxWidth="250px" ml="20px" mb="20px"><b>Kullanıcının İzleme Sayısı</b> <hr />{userWatches.length}</Typography>
                        }
                        {userId && userWatches && userWatches.length > 0 &&
                            <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="150px" maxWidth="250px" ml="20px" mb="20px">
                                <b>Kullanıcının Kuponu Bulduğu Yer</b>
                                <hr />
                                {userWatches.map((watch) => <p>{getFindFromStr(watch.find_from)}</p>)}
                            </Typography>
                        }
                    </Box>

                    <Box m="30px 20px 0 20px" pb="30px">

                        {ad?.has_coupons !== 0 &&
                            <Accordion disabled={brandProducts.length < 1}>
                                <AccordionSummary id='coupon-accordion' expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant='h4'>Ürünler</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box m="10px 0 0 0" maxHeight="500px" overflow="auto">
                                        <InfiniteScroll
                                            dataLength={brandProducts.length}
                                            next={() => getBrandProducts(brandProducts.length)}
                                            hasMore={hasMoreProduct}
                                            loader={<h4>Yükleniyor...</h4>}
                                            endMessage={
                                                <p style={{ textAlign: 'center' }}>
                                                    <b>Tüm ürünleri görüntülüyorsunuz.</b>
                                                </p>
                                            }
                                        >
                                            {brandProducts.map((product) => <BrandProductBox
                                                key={product.id}
                                                brandProduct={product}
                                                onEditClick={handleEditProduct}
                                                onDeleteClick={(product) => setTargetProductToDelete(product)}
                                            />)}
                                        </InfiniteScroll>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {data &&
                            <Accordion disabled={bubbles.length < 1}>
                                <AccordionSummary id='coupon-accordion' expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant='h4'>Baloncuklar</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box m="10px 0 0 0">
                                        <Box>
                                            {bubbles.map((bubble) => <BubbleBox key={bubble.id + "bubble"} bubble={bubble} />)}
                                        </Box>
                                        <Box>
                                            <Bubble options={{
                                                responsive: true,
                                                scales: {
                                                    y: {
                                                        ticks: { color: colors.grey[400], stepSize: 100 },
                                                        grid: {
                                                            color: colors.grey[400]
                                                        },
                                                        beginAtZero: true, max: ad && ad.vertical === 1 ? 1920 : 1080
                                                    },
                                                    x: {
                                                        ticks: { color: colors.grey[400], stepSize: 100 },
                                                        grid: {
                                                            color: colors.grey[400]
                                                        },
                                                        beginAtZero: true, max: ad && ad.vertical === 1 ? 1080 : 1920
                                                    }
                                                }
                                            }} data={data} />
                                        </Box>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        }
                        <Accordion disabled={adQuestions.length < 1}>
                            <AccordionSummary id='coupon-accordion' expandIcon={<ExpandMoreIcon />}>
                                <Typography variant='h4'>Reklam Soruları</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box m="10px 0 0 0" maxHeight="500px">
                                    {adQuestions.map((adQuestion) => <QuestionBox key={adQuestion.id + "adQuestion"} question={adQuestion} />)}
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default CouponDetails;